/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Feature4Inputs */

const ja_playdata_pricing_feature4 = /** @type {(inputs: Playdata_Pricing_Feature4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャンネル別の累計視聴時間`)
};

const en_playdata_pricing_feature4 = /** @type {(inputs: Playdata_Pricing_Feature4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumulative viewing hours by channel`)
};

/**
* | output |
* | --- |
* | "Cumulative viewing hours by channel" |
*
* @param {Playdata_Pricing_Feature4Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_feature4 = /** @type {((inputs?: Playdata_Pricing_Feature4Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Feature4Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_feature4(inputs)
	return en_playdata_pricing_feature4(inputs)
});